import { AfterContentInit, Directive, ElementRef, inject, OnDestroy, OnInit } from '@angular/core';

import { KROS_FORM_FIELD_HOST } from '../kros-form-field/kros-form-field.token';

@Directive({
  selector: '[krosPrefix], i[krosIconPrefix]',
  standalone: false,
})
export class KrosPrefix implements OnInit, OnDestroy, AfterContentInit {
  private readonly formFieldPrefixClass = 'kros-form-field-infix-left';

  #formField = inject(KROS_FORM_FIELD_HOST);
  #elementRef = inject(ElementRef);

  #isIconPrefix = false;

  ngOnInit(): void {
    const hostEl = this.#elementRef.nativeElement as HTMLElement;
    this.#isIconPrefix = hostEl.tagName.toLowerCase() === 'i' && hostEl.hasAttribute('krosIconPrefix');

    if (this.#isIconPrefix) {
      this.#formField.addClass(this.formFieldPrefixClass);
    }
  }

  ngAfterContentInit(): void {
    if (this.#isIconPrefix) return;

    setTimeout(() => this.updatePadding());
  }

  ngOnDestroy(): void {
    if (this.#isIconPrefix) {
      this.#formField.removeClass(this.formFieldPrefixClass);
      return;
    }

    this.#formField.removeStyle('padding-left');
  }

  private getPrefixContainer(): HTMLElement | null {
    return (this.#elementRef.nativeElement as HTMLElement).closest('.kros-form-field-icon-prefix');
  }

  private updatePadding(): void {
    const controlEl = this.#formField.control?.elementRef?.nativeElement as HTMLElement | undefined;
    const prefixContainer = this.getPrefixContainer();

    if (!controlEl || !prefixContainer) return;

    const containerRect = prefixContainer.getBoundingClientRect();
    const controlRect = controlEl.getBoundingClientRect();

    const spacingPx = 0;
    const requiredPadding = Math.max(0, Math.round(containerRect.right - controlRect.left) + spacingPx);

    this.#formField.addStyle('padding-left', `${requiredPadding}px`);
  }
}
